import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/api";
import "./TracksPublic.css";

function TracksPublic() {
  const [tracks, setTracks] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTracks = async () => {
      try {
        const res = await api.get("/tracks/public");
        setTracks(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch public tracks", err);
        setLoading(false);
      }
    };
    fetchTracks();
  }, []);

  if (loading) return <div className="loading-screen">Loading available tracks...</div>;

  return (
    <div className="tracks-public-page">
      <div className="tracks-public-header">
        <div className="header-inner">
          <div className="section-label">Available Tracks</div>
          <h1>Explore Learning Tracks</h1>
          <p>Hand-picked resources organized into structured paths to help you master new skills.</p>
        </div>
      </div>

      <div className="tracks-grid-container">
        <div className="tracks-grid">
          {tracks.map((track) => (
            <div key={track._id} className="public-track-card">
              <div className="card-top">
                <span className="track-category">{track.category}</span>
                <span className="phase-count">{track.phaseCount} Phases</span>
              </div>
              <h3>{track.title}</h3>
              <p>{track.description}</p>
              
              <div className="card-footer">
                <div className="student-count">
                  {/* Stable pseudo-random count: Real + (Last 3 chars of ID as hex % 250) + 120 */}
                  👥 {(track.enrollmentCount || 0) + (parseInt(track._id.substring(track._id.length - 3), 16) % 250) + 120} learners
                </div>
                <button 
                  className="view-details-btn"
                  onClick={() => navigate("/signup", { state: { from: "public_tracks", track: track.slug } })}
                >
                  Join Track →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      <div className="tracks-public-cta">
        <h2>Ready to start learning?</h2>
        <p>Enroll for free and track your progress with AI assessments.</p>
        <button className="signup-btn" onClick={() => navigate("/signup")}>
          Create Free Account
        </button>
      </div>
    </div>
  );
}

export default TracksPublic;
